import { Link } from 'react-router-dom';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function WalkInCTA() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.15 });

  const handleBook = () => {
    const btn = document.querySelector('#vapi-widget-floating-button') as HTMLElement | null;
    if (btn) btn.click();
  };

  return (
    <section className="py-28 bg-gradient-to-br from-[#FFFBEB] via-white to-[#FEF3C7]/40 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-brand-yellow/12 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-brand-yellow/8 rounded-full blur-3xl pointer-events-none" />

      <div ref={ref} className="relative z-10 max-w-screen-xl mx-auto px-4 sm:px-8">
        <div className={`scroll-hidden ${isVisible ? 'scroll-visible' : ''} rounded-3xl bg-gradient-to-br from-[#1E3A8A] via-[#2D1B69] to-[#5B21B6] p-12 sm:p-20 text-center relative overflow-hidden`}>

          {/* Subtle glow decoration */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-32 pointer-events-none"
            style={{ background: 'radial-gradient(ellipse, rgba(245,158,11,0.15) 0%, transparent 70%)' }} />

          {/* Price badge */}
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-brand-yellow/20 border border-brand-yellow/40 text-brand-yellow font-body text-sm font-bold mb-8">
            <i className="ri-car-line text-base" />
            $30 · Mobile-Based · We Come to You
          </div>

          <h2 className="font-heading text-white text-5xl sm:text-6xl font-black leading-tight mb-6">
            Ready to Get Started?
          </h2>
          <p className="font-body text-white/70 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed mb-12">
            Call or message us, pick your instrument, and we&apos;ll come to you. One hour of real instruction, $30 flat — it might just be the best decision you make today. No regrets, no strings attached.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 flex-wrap">
            <button
              onClick={handleBook}
              className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-10 py-4 rounded-full bg-brand-yellow text-brand-blue-dark font-body font-bold text-base cursor-pointer hover:bg-yellow-300 transition-all"
            >
              <i className="ri-calendar-check-line text-lg" /> Book a Walk-In Slot
            </button>
            <a
              href="tel:9102424567"
              className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-10 py-4 rounded-full border-2 border-white/40 text-white font-body font-semibold text-base cursor-pointer hover:border-white hover:bg-white/10 transition-all"
            >
              <i className="ri-phone-line text-lg" /> 910-242-4567
            </a>
            <Link
              to="/enroll"
              className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-10 py-4 rounded-full border-2 border-white/20 text-white/65 font-body font-semibold text-base cursor-pointer hover:border-white/50 hover:text-white transition-all"
            >
              Or Enroll for Ongoing Lessons
            </Link>
          </div>

          {/* Bottom micro info */}
          <p className="font-body text-white/35 text-xs mt-10 uppercase tracking-widest">
            Mobile-Based · Mon – Sat · 9:00 AM – 9:00 PM · Fayetteville, NC &amp; Surrounding Areas
          </p>
        </div>
      </div>
    </section>
  );
}
